var React = require('react');

function Hockeyapp (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("path",{"fill":"#1C9DD8","fillRule":"nonzero","d":"M29.06 20.12c.1-.08.24 0 .26.1v.23c0 2.08-4.43 4.9-13.32 4.9-8.9 0-13.33-2.83-13.33-4.9v-.2c.03-.14.17-.2.27-.12 2.2 1.57 6.56 2.9 13.06 2.9 6.5 0 10.86-1.33 13.06-2.9zM16 19.02c-7.2 0-11.98-1.6-14.32-3.47-.08-.07-.2-.04-.25.05-.12.23-.18.48-.18.74 0 2.3 4.92 5.36 14.75 5.36s14.75-3.06 14.75-5.36c0-.26-.06-.5-.18-.74-.05-.1-.17-.12-.25-.05-2.34 1.86-7.1 3.47-14.32 3.47zm16-7.5c0 2.64-5.33 6.17-16 6.17S0 14.14 0 11.5C0 8.87 5.33 7 16 7s16 1.86 16 4.5zm-4.67-.43C27.33 9.74 23.56 9 16 9c-7.56 0-11.33.76-11.33 2.1 0 1.32 3.77 3.25 11.33 3.25 7.56 0 11.33-1.93 11.33-3.26z","style":{"fill":"#1C9DD8"}})));
}

Hockeyapp.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Hockeyapp;

Hockeyapp.default = Hockeyapp;
